import React, { PropsWithChildren } from "react";
import { DownloadManagerContext } from "./DownloadManagerContext";
import { downloadManager } from "./DownloadManager";

const DownloadManagerContextProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <DownloadManagerContext.Provider value={downloadManager}>
      {children}
    </DownloadManagerContext.Provider>
  );
};

export default DownloadManagerContextProvider;
